export default function (value) {
	const seconds = parseInt(value, 10)
	const minutes = Math.floor(seconds / 60)
	const hours = Math.floor(minutes / 60)
	const days = Math.floor(hours / 24)
	const months = Math.floor(days / 30)
	const years = Math.floor(days / 365)

	const output = []
	if (years) {
		output.push(`${years}y`)
	}
	if (months) {
		output.push(`${months % 12}m`)
	}
	if (days) {
		output.push(`${days % 30}d`)
	}
	if (hours) {
		output.push(`${hours % 24}h`)
	}
	if (minutes) {
		output.push(`${minutes % 60}m`)
	}
	output.push(`${seconds % 60}s`)

	return output.join(' ')
}
